import { useState, useEffect } from 'react'
import { supabase } from '../../../lib/supabase'
import * as Sentry from '@sentry/react'

export interface AgentSearchResult {
    id: string
    name: string
    description?: string
    avatar_url?: string | null
}

export const useAgentSearch = (userId: string | null, isOpen: boolean) => {
    const [agents, setAgents] = useState<AgentSearchResult[]>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        async function loadAgents() {
            if (!userId || !isOpen) return

            setIsLoading(true)
            try {
                const { data, error } = await supabase
                    .from('agents')
                    .select('id, name, function_description, avatar_url')
                    .eq('user_id', userId)
                    .order('updated_at', { ascending: false })

                if (error) throw error

                if (data) {
                    setAgents(data.map(agent => ({
                        id: agent.id,
                        name: agent.name,
                        description: agent.function_description || undefined,
                        avatar_url: agent.avatar_url
                    })))
                }
            } catch (error) {
                Sentry.captureException(error, {
                    tags: { hook: 'useAgentSearch', action: 'loadAgents' }
                })
            } finally {
                setIsLoading(false)
            }
        }

        loadAgents()
    }, [userId, isOpen])

    return { agents, isLoading }
}
